<mat-form-field class="user-search-field" [ngClass]="styleClass()" [floatLabel]="floatLabel()" appearance="fill">
  <mat-label>
    @if (label(); as label) {
      {{ label }}
    } @else {
      {{ 'SEARCH_FOR_A_USER_OR_TYPE_EMAIL' | translate }}
    }
  </mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchCtrl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder()"
    [required]="required()"
    autocomplete="off"
    (blur)="markTouched()"
    (keyup.enter)="enter.emit(searchCtrl.value)" />

  @if (searchCtrl.value) {
    <button matSuffix mat-icon-button type="button" class="search-clear-button" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectItem($event)">
  @for (user of autocompleteOptions(); track trackUser(user)) {
    <mat-option [value]="user">
      @if ('isCreateEmailOption' in user) {
        {{ 'CREATE_ACCOUNT_FOR_EMAIL' | translate }}:
        <strong>{{ user.Email }}</strong>
      } @else {
        <div class="flex items-center justify-between">
          @if (user.MatchType === 'AccessCard') {
            <mat-icon class="search-option__icon txt-gray">sell</mat-icon>
          } @else if (user.MatchType === 'Vehicle') {
            <mat-icon class="search-option__icon txt-gray">car_tag</mat-icon>
          }
          <span class="search-option">
            @if (user.Name || user.PhoneNumber || user.Email) {
              @if (user.Name) {
                <span [innerHTML]="user.Name | highlight: searchCtrl.value"></span>
              }
              @if (user.PhoneNumber) {
                <span
                  [ngClass]="{ address: user.Name }"
                  [innerHTML]="user.PhoneNumber | highlight: searchCtrl.value"></span>
              }
              @if (user.Email) {
                <span
                  [ngClass]="{ address: user.Name || user.PhoneNumber }"
                  [innerHTML]="user.Email | highlight: searchCtrl.value"></span>
              }
            } @else if (user.CustomerIdentificator) {
              <span [innerHTML]="user.CustomerIdentificator | highlight: searchCtrl.value"></span>
            }
          </span>
          <span class="operator-logo" *canSee="UserType.Admin">
            <div class="flex-center">
              <img [matTooltip]="user.OperatorName" [src]="user.OperatorLogoURL || 'assets/img/current_c.svg'" />
            </div>
          </span>
        </div>
      }
    </mat-option>
  }

  @if (isLoading()) {
    <mat-option disabled>
      {{ 'SEARCHING' | translate }}
    </mat-option>
  }
</mat-autocomplete>
